
export default {
  name: 'sgh-news-letter',
  props: {
    textColor: {
      type: String,
      default: 'cms-custom-text-color-white',
    },
    bgColor: {
      type: String,
      default: 'cms-custom-color-mine-shaft',
    },
  },
}
